<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Listado de Items del dia</p>
        </template>
        <b-row class="pb-3">                            
            <b-col cols="12" md="12">
                <div class="text-right">
                    <b-button variant="info" class="text-white" @click="$emit('open-search-item-modal')">Nuevo Item del dia</b-button>
                </div>
            </b-col>
        </b-row>
        <b-card-text>
            <b-table 
                responsive
                :fields="fields" 
                striped hover 
                :items="items">
                <template v-slot:cell(imagen)="{ item }">
                    <b-img :src="item.imagen" alt="Image 1" style="max-width: 100%; max-height: 100px; object-fit: scale-down;"></b-img>
                </template>
                <template v-slot:cell(item_reference)="data">
                    {{ data.item.item_reference }}
                </template>
                <template v-slot:cell(quantities)="data">
                    {{ data.item.quantities }}
                </template>
                <template v-slot:cell(created_at)="data">
                    {{ data.item.created_at }}
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button variant="danger" size="sm" v-b-tooltip.hover title="Eliminar Registro" class="text-white" 
                        @click="$emit('open-delete-modal', item)">
                        <b-icon icon="trash"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <template v-if="items.length < 1">
                <b-alert show variant="danger">
                    No tiene registrados items recomendados en la base de datos.
                </b-alert>
            </template>
        </b-card-text>
    </b-card>
</template>

<script>
export default {
    name: "itemsTable",
    props: {
        items: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        }
    },
    data(){
        return{
            fields: [
                { key: 'imagen', label: 'Imagen', sortable: true},
                { key: 'item_reference', label: 'Codigo referencia', sortable: true},
                { key: 'quantities', label: 'Existencia', sortable: true},
                { key: 'created_at', label: 'Data Registro', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
            company: {},
        }
    },
    methods: {
        updatePageSize(){
            /* the page sizee return the current page to initial because we can't know if the current page have items asigned!! */
            this.paginator.page = 1;
            /* emit the page size update to get the new list of items*/
            this.$emit('get-items');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);
        }
    }
};

</script>
<style scoped>

</style>